/*
|--------------------------------------------------------------------------
| Utilities: Tracker
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.utilities.tracker = {
	"init": function() {
		var currentPage 	= __gh__webApp.currentPage,
			commonJS		= __gh__webApp.common,
			googleAnalytics = __gh__webApp.analytics.google,
			url				= document.location.href,
			urlref			= document.referrer,
			siteData 		= __gh__coreData.siteData;
	
		if (!commonJS.isObjectPropertySet(siteData,"providers.analytics.google")){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.tracker",message:"Google analytics not set in siteData > providers > analytics > google."});
			return;
		}
		
		this.addCustomRollUps();
		
		__gh__webApp.analytics.google = googleAnalytics[siteData.providers.analytics.google];
		__gh__webApp.analytics.google.init();
		__gh__webApp.analytics.parsely.track({"url":url,"urlref":urlref});
		
		this.bindEvents();
	},
	
	
	/**
	 * Add custom rollup accounts to the Google Analytics rollup accounts based on taxonomies in the campaigns node
	 */
 	"addCustomRollUps": function() {
		var currentPage 	 = __gh__webApp.currentPage,
			commonJS		 = __gh__webApp.common,
			isCampaigns		 = commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.google.custom.campaigns"),
			campaigns 	 	 = (isCampaigns) ? __gh__coreData["3rdPartyData"].analytics.google.custom.campaigns : [],
			buckets			 = __gh__coreData.pageData.buckets,
			hasBuckets		 = buckets.length > 0,
			bucketIndex,bucketTaxonomies,useBucket1,useBucket2;
		
		
		//Do not add rollups
		if (!hasBuckets || currentPage.isHome() || !campaigns.length){ return; }
		
		
		//Get bucket taxonomies from first or second bucket
		useBucket1 				= ("taxonomy" in buckets[0] && buckets[0].taxonomy.length);
		useBucket2				= (!useBucket1 && buckets[1] && "taxonomy" in buckets[1] && buckets[1].taxonomy.length);
		bucketIndex				= (useBucket1) ? 0 : false; 
		bucketIndex		 		= (!useBucket1 && useBucket2) ? 1 : bucketIndex;
		bucketTaxonomies 		= (bucketIndex !== false) ? buckets[bucketIndex].taxonomy : false;
	
		
		//Do not add rollups
		if (!bucketTaxonomies || !bucketTaxonomies.length){ return; }
		
		
		//Get a UA code for a campaign based on whether the taxonomy exists
		function addCampaignUAsToRollupsArray(taxomony){
			
			for(var j=0;j < campaigns.length;j++){
				var campaign 	= campaigns[j];
	
				// No match
				if (!commonJS.inArray(taxonomy,campaign.taxonomies,true)) { continue; }
				
				var ua 		= campaign.ua,
					rollups = __gh__coreData["3rdPartyData"].analytics.google.rollups;
				
				//Already exists in rollups
				if (commonJS.inArray(ua,rollups)) { continue; }
				
				//Add to rollups array
				__gh__coreData["3rdPartyData"].analytics.google.rollups.push(ua);
			}
		}
		
	
	
		// Run through the bucket taxonomies and check against campaigns
		for(var i=0;i < bucketTaxonomies.length;i++){
			var taxonomy = bucketTaxonomies[i];
			addCampaignUAsToRollupsArray(taxonomy);
		} 
	
		
	},



	/**
	 * Article tracking
	 */
	"trackArticle": {

		/**
		 * Main tracking function used for tracking an article page
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"main": function(options){
			var thisTracker 		= __gh__webApp.utilities.tracker,
				commonJS			= __gh__webApp.common,
				siteData			= __gh__coreData.siteData,
				articleObject		= ("articleObject" in options) ? options.articleObject : null,
				customDimensions 	= ("customDimensions" in options) ? options.customDimensions : null,
				articleURL			= (articleObject && "link" in articleObject) ? articleObject.link : null,
				articleTitle		= (articleObject && commonJS.isObjectPropertySet(articleObject,"title")) ? articleObject.title : null,
				articleTitle		= articleTitle +" - "+ articleObject.category +" - "+ siteData.siteTitle +" - "+ siteData.locationData.city +", "+ siteData.locationData.state.abbr;
		
			if (!articleURL){
				__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.main",message:"Missing articleURL."});
				return;
			}
			
			thisTracker.trackURL({"url": articleURL,"title":articleTitle,"customDimensions":customDimensions});
			//thisTracker.trackArticle.author(articleObject);
		},
		
		/**
		 * Tracks anytime an article is loaded (both read more articles and main article)
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"allArticlesOnLoad": function(options){
			var trackArticle 	= __gh__webApp.utilities.tracker.trackArticle,
				commonJS		= __gh__webApp.common,
				analytics		= __gh__webApp.analytics,
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
			
			analytics.salesforce.trackArticle(articleObject);
		},
		
		
		/**
		 * Tracking specific to the main article loading
		 */
		"mainArticle": function(options){
			/*var thisTracker 	= __gh__webApp.utilities.tracker;
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
				//thisTracker.trackArticle.author(articleObject)*/
		},
		
		
		/**
		 * Tracking specific to the when someone clicks a read more card and it shows the full article
		 */
		"readMoreFullArticle": function(options){
			var trackArticle 		= __gh__webApp.utilities.tracker.trackArticle,
				articleObject		= ("articleObject" in options) ? options.articleObject : null,
				customDimensions	= __gh__webApp.analytics.google.getArticleCustomDimensionsObject(articleObject);
				customDimensions.pageType = "Article - Read More";
				
				trackArticle.main({"articleObject":articleObject,"customDimensions":customDimensions});
		},


		/**
		 * Track only author
		 * @param {object} options
		 * @param {object} options.articleObject - article json object
		 */
		"author": function(options){
			var thisTracker 	= __gh__webApp.utilities.tracker,
				commonJS		= __gh__webApp.common,
				articleObject	= ("articleObject" in options) ? options.articleObject : null;
				authorPath 		= (articleObject && commonJS.isObjectPropertySet(articleObject,"track.authorPath")) ? options.authorPath : null;
				if (!authorPath){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing author path."});
					return;
				}
				setTimeout(function() {
				  thisTracker.trackEvent({"category":authorPath});
				}, 1000);
		},


		/**
		 * Track article pagination
		 * @param {object} options
		 * @param {string} options.articlePath - url path for article
		 * @param {string} options.authorPath - url path for author
		 * @param {string} options.articleTitle - title of the Article
		 * @param {number} options.pageNumber - page number for the article
		 */
		"pagination": function(options){
			var thisTracker 	= __gh__webApp.utilities.tracker,
				commonJS			= __gh__webApp.common,
				articleObject		= ("articleObject" in options) ? options.articleObject : null,
				articlePath			= (articleObject && commonJS.isObjectPropertySet(articleObject,"track.articlePath")) ? articleObject.track.articlePath : null,
				articleTitle		= (articleObject && commonJS.isObjectPropertySet(articleObject,"title")) ? articleObject.title : null;
				pageNumber			= ("pageNumber" in options) ? options.pageNumber : null,
				paginationPath 		= articlePath +"/pagination/"+pageNumber;

				if (!articlePath){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing articlePath."});
					return;
				}

				if (!pageNumber){
					__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.trackArticle.author",message:"Missing pageNumber."});
					return;
				}

				thisTracker.trackPage({"path": paginationPath,"title":articleTitle});
		},


		/**
		 * Track article read more clicks
		 */
		"readMoreClick": function(options){
			var thisTracker = __gh__webApp.utilities.tracker;
			thisTracker.trackEvent(options);
		}
	},


	/**
	 * Track an event
	 */
	"trackEvent": function(options){
		var googleAnalytics = __gh__webApp.analytics.google;
			googleAnalytics.trackEvent(options);

	},


	/**
	 * Track a photo gallery
	 * @param {string} path - path for gallery
	 */
	"trackGallery": function(options){
		var currentPage				= __gh__webApp.currentPage,
			auditedMedia			= __gh__webApp.analytics.auditedMedia,
			googleAnalytics 		= __gh__webApp.analytics.google,
			parsely 				= __gh__webApp.analytics.parsely,
			comscore				= __gh__webApp.analytics.comscore,
			defaultURL				= location.protocol + '//' + location.host + location.pathname,
			galleryTitle 			= ("galleryTitle" in options) ? options.galleryTitle : null,
			imageURL 				= ("imageURL" in options) ? options.imageURL : defaultURL,
			galleryURL 				= ("galleryURL" in options) ? options.galleryURL : defaultURL,
			isRelatedImageGallery	= ("isRelatedImageGallery" in options) ? options.isRelatedImageGallery : null,
			parselyGalleryURL		= (!galleryURL) ? defaultURL : galleryURL,
			urlref					= document.referrer,
			customDimensions		= {
				"pageType": "Gallery",
				"category": (isRelatedImageGallery) ? "Related Images" : "Photo Gallery"
			};

		googleAnalytics.trackPage({"url": imageURL,"title": galleryTitle,"customDimensions":customDimensions});
		parsely.track({"url":parselyGalleryURL,"urlref":urlref});
		comscore.track();
		auditedMedia.trackGallery();
	},
	
	/**
	 * Track Infinite Scroll
	 */
	"trackInfiniteScroll": function(options){
		var thisTracker 		= __gh__webApp.utilities.tracker,
			pageTitle			= ("title" in options) ? options.title : null,
			customDimensions	= {
				"pageType": __gh__coreData.pageData.pageType2 + " - Infinite Scroll",
				"category": __gh__coreData.pageData.categoryName
			};
			
		thisTracker.trackURL({"title":pageTitle,"customDimensions":customDimensions});
	},
	


	/**
	 * Track a page
	 * @param {object} options
	 * @param {string} options.path - path portion of url (ie "/url-path")
	 * @param {string} [options.title=null] - title
	 */
	"trackPage": function(options){
		var googleAnalytics 	= __gh__webApp.analytics.google,
			path 				= ("path" in options) 	? options.path : location.protocol + '//' + location.host + location.pathname,
			title 				= ("title" in options) 	? options.title : null,
			parsely 			= __gh__webApp.analytics.parsely,
			urlref				= document.referrer;

		googleAnalytics.trackPage({"path": path,"title": title});
		parsely.track({"url":path,"urlref":urlref});
	},
	
	
	/**
	 * Track Pagination
	 */
	"trackPagination": function(options){
		var thisTracker 		= __gh__webApp.utilities.tracker,
			pageTitle			= ("title" in options) ? options.title : document.title;
			
		thisTracker.trackURL({"title":pageTitle});
	},
	
	
	/**
	 * Track Search
	 */
	"trackSearch": {
		
		/**
		 * Track each time search results are loaded (includes pagination, filtering ect)
		 * @param {object} options
		 * @param {string} options.searchText - text that was searched for
		 */
		"loadSearchResults": function(options){
			var thisTracker = __gh__webApp.utilities.tracker,
				analytics	= __gh__webApp.analytics,
				searchText 	= ("searchText" in options) ? options.searchText : null;
			
			thisTracker.trackURL();
			analytics.salesforce.trackSearch(searchText);
			
		}
		
	},
	
	
	/**
	 * Track Newsletter Sign Up
	 * @param {object} options
	 * @param {string} options.email - email address
	 */
	 "trackNewsletterSignUp": function(options){
		 var analytics	= __gh__webApp.analytics,
			 email 	= ("email" in options) ? options.email : null;
		
		analytics.salesforce.trackNewsletterSignUp(email);
	 },


	/**
	 * Track social stuff
	 */
	"trackSocial":{
		
		/**
		 * Track social buttons
		 */
		"shareButtonClick":function(data){
			var analytics = __gh__webApp.analytics;
				analytics.salesforce.trackSocial(data);
		},
	},

	/**
	 * Track Tout video
	 */
	"trackToutVideo": function(options){
		//var googleAnalytics = __gh__webApp.analytics.google;
	},


	/**
	 * Track a url
	 * @param {object} options
	 * @param {string} options.url - full url or url path, it'll be converted to a path
	 * @param {string} [options.title=null] - title
	 */
	"trackURL": function(options){
		var googleAnalytics 	= __gh__webApp.analytics.google,
			commonJS			= __gh__webApp.common,
			options 			= options || {},
			url					= ("url" in options) 	? options.url 	: document.location.href,
			customDimensions	= ("customDimensions" in options) 	? options.customDimensions 	: null,
			title				= ("title" in options) 	? options.title : document.title,
			urlPath 			= commonJS.getURLPath(url),
			parsely 			= __gh__webApp.analytics.parsely,
			urlref				= document.referrer;
			
			googleAnalytics.trackPage({"url": url,"title": title, "customDimensions": customDimensions});
			parsely.track({"url":urlPath,"urlref":urlref});
	},


	/**
	 * Bind Events
	 */
	"bindEvents": function(){
		var thisTracker = this;

		
		//Track Article Factbox links
		$(document).on('click','[data-gh-tracker-track-factbox-object] a',function(){
			var $this 			= $(this);
				trackerObject 	= $this.closest("[data-gh-tracker-track-factbox-object]").data("gh-tracker-track-factbox-object"),
				pageTitle		= $this.closest("article").find("h1.headline").html(),
				pagePath		= window.location.pathname;
	
			thisTracker.trackEvent({
				'action'			: $this.attr("title"),
				"label"				: pagePath+","+pageTitle,
				"category"			: (trackerObject.category) ? trackerObject.category : '',
			});
		});

		//Track Event
		$(document).on('click','[data-gh-tracker-track-event-object]',function(){
			var trackerObject = $(this).data("gh-tracker-track-event-object");
				thisTracker.trackEvent({
					'action'			: trackerObject.action,
					"label"				: trackerObject.label,
					"category"			: trackerObject.category,
					"value"				: trackerObject.value,
					"nonInteraction"	: trackerObject.nonInteraction
				});
		});
	
		//Track Page
		$(document).on('click','[data-gh-tracker-track-page-object]',function(){
			var trackerObject = $(this).data("gh-tracker-track-page-object")
				thisTracker.trackPage({
					'path'				: trackerObject.path,
					'title'				: trackerObject.title
				});
		});


		//Track slider
		$(document).on('click','[data-gh-tracker-track-slider-object] a,[data-gh-tracker-track-slider-object] button',function(event){

			var $this 		= $(this),
				trackObject = $this.closest("[data-gh-tracker-track-slider-object]").data("gh-tracker-track-slider-object"),
				commonJS	= __gh__webApp.common,
				isButton	= $this.prop("tagName").toLowerCase() == "button",
				isSwipe		= event.type == "swipe",
				isLink		= $this.prop("tagName").toLowerCase() == "a";
			
			if (isLink){
				trackObject.action 	= $this.attr("title");
				trackObject.label 	= $this.attr("href");
				return thisTracker.trackEvent(trackObject);
			}

			if (isButton){
				trackObject.action = ($this.hasClass("slick-prev")) ? "arrow left" : null;
				trackObject.action = ($this.hasClass("slick-next")) ? "arrow right" : trackObject.action;
				trackObject.action = (!trackObject.action) ? "dot" : trackObject.action;
				return thisTracker.trackEvent(trackObject);
			}

		});
		$(document).on('swipe','[data-gh-tracker-track-slider-object]',function(event, slick, direction){
			var trackObject 		= $(this).data("gh-tracker-track-slider-object");
				trackObject.action 	= "swipe "+ direction;
				return thisTracker.trackEvent(trackObject);
		});


	}
};